import React from 'react';
import includes from 'ramda/src/includes';
import isNil from 'ramda/src/isNil';
import cx from 'classnames';
import Avatar from '@components/@core/Avatar';
import { inPage } from '~/services/util';
import { KEYS, TITLES } from './Constants';

const Body = ({ data, type, page, per, total, column, userIds }) => {
    if (isNil(data)) return null;
    if (isNil(total)) return null;

    return (
        <>
            <div className="engagement engagement-titles">
                <div className="d-flex-2 d-flex-sm-1 pb-3 pm-md-2">
                    <span className="dsl-m12 text-400">Company</span>
                </div>
                {TITLES[type].map((title, index) => (
                    <div
                        className={cx(
                            'd-flex-1 text-400 text-end d-none d-md-block pb-3 pb-md-0 ms-2',
                            index <= 1 && column == 1 && 'd-block',
                            index > 1 && index <= 3 && column == 2 && 'd-block',
                            index > 3 && index <= 5 && column == 3 && 'd-block',
                            index > 5 && index <= 7 && column == 4 && 'd-block'
                        )}
                        key={title}
                    >
                        <p className="dsl-m12 mb-0 text-400">{title[0]}</p>
                        <p className="dsl-m12 mb-0 text-400">{title[1]}</p>
                    </div>
                ))}
            </div>
            {isNil(data) || data.length === 0 || isNil(total) ? (
                <div className="no-records">
                    <p className="dsl-m12">No records available</p>
                </div>
            ) : (
                <div>
                    {total.map((total, index) => (
                        <div className="engagement pb-0 pb-md-4 py-2" key={index}>
                            <div className="d-flex d-flex-2 d-flex-sm-1 align-items-center py-2">
                                <span className="dsl-b14 text-400">Total</span>
                            </div>
                            {KEYS[type].length > 0 ? (
                                KEYS[type].map((key, i) => (
                                    <div
                                        className={cx(
                                            'd-flex text-end d-flex-1 d-md-block ms-2 engagement-details',
                                            i <= 1 && column == 1 && 'd-block',
                                            i > 1 && i <= 3 && column == 2 && 'd-block',
                                            i > 3 && i <= 5 && column == 3 && 'd-block',
                                            i > 5 && i <= 7 && column == 4 && 'd-block',
                                            i % 2 == 0 ? 'pt-md-0' : 'list-item',
                                            KEYS[type].length == i + 1 && 'pt-md-0'
                                        )}
                                        key={`${index}-${key}`}
                                    >
                                        <div className="w-40 mobile-screen">
                                            <p className="dsl-m12 mb-0 text-400 text-capitalize">{`${key.split('_')[0]} ${key.split('_')[1]}`}</p>
                                        </div>
                                        <p className="dsl-b14 mb-1 ms-3 w-sm-10 text-400">{key.includes('completion') ? total[key]?.complete : total[key]?.count || 0}</p>
                                        <p className="dsl-m12 mb-0 ms-1">{total[key]?.percent || 0}%</p>
                                    </div>
                                ))
                            ) : (
                                <div className="dsl-d14 d-flex-3 text-center empty-message">No records available</div>
                            )}
                        </div>
                    ))}
                    {data.map((company, index) => {
                        if ((userIds.length > 0 && includes(company.id, userIds)) || (userIds.length === 0 && inPage(index, page, per)))
                            return (
                                <div className="engagement pb-0 pb-md-4 py-2" key={company.id}>
                                    <div className="d-flex-2 d-flex-sm-3 d-flex align-items-center me-2 me-md-0 py-2">
                                        <Avatar name={company.name} url={`${company.avatar}${Date.now()}`} />
                                        <span className="dsl-b14 ms-3 cursor-pointer text-400">{company.name}</span>
                                    </div>
                                    {KEYS[type].length > 0 ? (
                                        KEYS[type].map((key, i) => (
                                            <div
                                                className={cx(
                                                    'd-flex text-end d-flex-1 d-md-block ms-2 engagement-details',
                                                    i <= 1 && column == 1 && 'ptd-block',
                                                    i > 1 && i <= 3 && column == 2 && 'd-block',
                                                    i > 3 && i <= 5 && column == 3 && 'd-block',
                                                    i > 5 && i <= 7 && column == 4 && 'd-block',
                                                    i % 2 == 0 ? 'pt-md-0' : 'list-item',
                                                    KEYS[type].length == i + 1 && 'pt-md-0'
                                                )}
                                                key={`${company.id}-${key}`}
                                            >
                                                <div class="w-40 mobile-screen">
                                                    <p class="dsl-m12 mb-0 text-400 text-capitalize">{`${key.split('_')[0]} ${key.split('_')[1]}`}</p>
                                                </div>
                                                <p className="dsl-b14 mb-1 ms-3 w-sm-10 text-400">{key.includes('completion') ? company.report[key]?.complete : company.report[key]?.count || 0}</p>
                                                <p className="dsl-m12 mb-0 ms-1">{company.report[key]?.percent || 0}%</p>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="dsl-d14 d-flex-3 text-center empty-message">No records available</div>
                                    )}
                                </div>
                            );
                    })}
                </div>
            )}
        </>
    );
};

export default Body;
